import { render } from "./MainFooter.vue?vue&type=template&id=3097fb8a&scoped=true"
import script from "./MainFooter.vue?vue&type=script&lang=js"
export * from "./MainFooter.vue?vue&type=script&lang=js"

import "./MainFooter.vue?vue&type=style&index=0&id=3097fb8a&scoped=true&lang=css"

import exportComponent from "/prj/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3097fb8a"]])

export default __exports__